export const DOCUMENT_INTERNAL_STAGE = {
  RE_EDITED_DOCUMENT: {
    name: "Re-edited document",
    color: "#6e7a8e",
    bg: "#ebf0f5",
  },
  SENT_FOR_INTERNAL_APPROVAL: {
    name: "Pending internal approval",
    color: "#8e5a0a",
    bg: "#fde2dd",
  },
  INTERNALLY_APPROVED: {
    name: "Internally approved",
    color: "#347aa5",
    bg: "#d3eeff",
  },
  INTERNALLY_REJECTED: {
    name: "Internally Rejected",
    color: "#a41c4e",
    bg: "#fde2dd",
  },
  SENT_FOR_FILL_BEFORE_ESIGN: {
    name: "Sent to fill before eSignature ",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  SENT_FOR_FILL_BEFORE_ACCEPT: {
    name: "Sent to fill before acceptance",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  SENT_FOR_ESIGN: {
    name: "Sent for eSignature ",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  SENT_FOR_ACCEPTANCE: {
    name: "Sent for acceptance",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  ALL_ESIGNED: { name: "All eSigned", color: "#0e6245", bg: "#cbf4c9" },
  ALL_ACCEPTED: { name: "All accepted", color: "#0e6245", bg: "#cbf4c9" },
  EVERYONE_FILLED_AND_SUBMITTED: {
    name: "Everyone filled and submitted",
    color: "#0e6245",
    bg: "#cbf4c9",
  },
  SOMEONE_DECLINED_ESIGN: {
    name: "eSignature declined",
    color: "#a41c4e",
    bg: "#fde2dd",
  },
  SOMEONE_DECLINED_ACCEPTANCE: {
    name: "Acceptance Declined",
    color: "#a41c4e",
    bg: "#fde2dd",
  },
  ESIGNATURE_LINK_EXPIRED: {
    name: "eSignature link expired",
    color: "#5F646C",
    bg: "#D8D8D8",
  },
  ESIGNATURE_LINK_UNEXPIRED: {
    name: "eSignature link unexpired",
    color: "#5F646C",
    bg: "#ffeacb",
  },
};

export const ASSET_DOC_TYPES = ["SLA", "SOW", "Quote", "MSA"];

export const REMINDER_FREQUENCIES = [
  { label: "Everyday", value: 1 },
  { label: "Every 2 days", value: 2 },
  { label: "Every 3 days", value: 3 },
  { label: "Every 4 days", value: 4 },
  { label: "Every 5 days", value: 5 },
  { label: "Every 6 days", value: 6 },
  { label: "Every 7 days", value: 7 },
];

export const REMINDER_DEL_METHODS = [
  { label: "SMS", value: "reminder_sms" },
  { label: "Push notification", value: "reminder_push_notification" },
  { label: "External apps", value: "reminder_external_apps" },
];
